import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ExternalApplicationOPEEnum} from "./ExternalApplicationOPEEnum";



class O {
}

/**
 * O Inner Class
 */
class I {
  id!: number;
  passedPartitionId!: number;
}


/**
 * UpdateExternalApplicationCB class
 */
export class UpdateExternalApplicationCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ExternalApplicationOPEEnum.UpdateExternalApplicationPartition);
    this.i = new I();
    this.o = new O();
  }

}
